export const MEMBERSHIP_PREVIEW_DATA_NOTICE =
  '현재 화면은 예시 데이터입니다.\n멤버십을 가입하시면 실제 내 마켓 데이터를 확인할 수 있어요!';
